import Loadable from "react-loadable";

export const PostModal = Loadable({
  loader: () => import("../../../../modules/post-modal").then((module) => module.PostModal) as Promise<any>,
  loading: () => null,
});
